"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";
import { useLeaderboard, getDisplayName } from "@/hooks/useLeaderboard";
import { QuestLogo } from "@/components/quest-logo";

export function LeaderboardSpotlightSection() {
  const { leaderboard, isLoading } = useLeaderboard('', 1);
  const topUser = leaderboard[0];

  return (
    <section className="relative w-full bg-black py-12 md:py-16 lg:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Left Column - Text Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
              Leaderboard Spotlight
            </h2>
            <p className="text-base md:text-lg text-neutral-400 leading-relaxed mb-6 md:mb-8 max-w-xl">
              Climb the leaderboard and compete with the Yiedl community for eye-catching rewards and assets. Follow your progress and earn more.
            </p>
            <Link href="/leaderboard">
              <Button
                variant="primary"
                size="sm"
                className="font-semibold rounded-xl transition-all duration-200 ease-out px-6 py-2 text-sm"
              >
                View Leaderboard
              </Button>
            </Link>
          </div>

          {/* Right Column - Leaderboard Image */}
          <div className="relative w-full aspect-square max-w-md mx-auto">
            <Image
              src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/leaderboard.png"
              alt="Leaderboard Spotlight"
              fill
              className="object-contain"
            />

            {/* Overlay Content - Positioned below the profile picture */}
            <div className="absolute inset-0 flex items-center justify-center pb-2">
              <div className="text-center space-y-1">
                {/* First Place Label */}
                <p className="text-xs md:text-sm font-medium text-neutral-400">
                  First Place
                </p>

                {/* Name */}
                <p className="text-base md:text-lg font-semibold text-white">
                  {isLoading ? 'Loading...' : (topUser ? getDisplayName(topUser) : 'No data')}
                </p>

                <div className="h-36 w-10" />

                {/* Points with Star Icon */}
                <div className="flex items-center justify-center gap-1.5">
                  <span className="text-xl md:text-2xl font-bold text-white">
                    {isLoading ? '...' : (topUser ? topUser.points.toLocaleString() : '0')}
                  </span>
                  <QuestLogo size={20} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
